// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"Y4-z","sponsoredTooltipWrapper":"Z4-z","sponsoredTooltip":"_4-z","newCard":"a5-z"};